import useFetchExternalStore from "@hooks/use-fetch-external-store";

import Button from "@stadium/shared/src/components/shared/button";
import { Spinner } from "@stadium/ui/src/components/loaders/loaders";
import SearchModalWithTrigger from "@components/swagmagic/shared/search-modal";
import { CountrySelector } from "@components/swagmagic/country-selector";
import ProfileDropdown from "@components/swagmagic/profile-dropdown";

import CheckoutProvider from "@contexts/checkout-context";

import LinkWithLangClient from "@components/swagmagic/dynamic/slices/client-link-with-lang";
import CartIcon from "@components/store/navigation/cart-icon";
import { HeaderCta } from "@components/swagmagic/header/type";

import { EXTERNAL_LINK_TYPE } from "@stadium/shared/src/constants/stores/routes";

import styles from "./main.module.scss";
export interface HeaderActionsProps {
  headerCta?: HeaderCta;
  setMenuPopup: React.Dispatch<React.SetStateAction<boolean>>;
  menuPopup: boolean;
}

const DEFAULT_OBJ = {};

export default function HeaderActions({
  headerCta,
  setMenuPopup,
  menuPopup,
}: Readonly<HeaderActionsProps>) {
  const {
    btnText: ctaButtonText,
    btnLink: ctaButtonLink = "/",
    openInNewTab = false,
  } = headerCta || (DEFAULT_OBJ as HeaderCta);
  const ctaUrl = ctaButtonLink || "/";
  const { loading } = useFetchExternalStore();

  const handleMenuToggle = () => {
    if (!menuPopup) {
      setMenuPopup(true);
    }
  };
  return (
    <>
      <CountrySelector />
      <div className={styles.ctaButton}>
        <LinkWithLangClient
          type={EXTERNAL_LINK_TYPE}
          data={{ url: ctaUrl }}
          className={styles.primaryBtn}
          target={openInNewTab ? "_blank" : "_self"}
          showExternalLinkIcon={openInNewTab}
        >
          {ctaButtonText}
        </LinkWithLangClient>
      </div>
      <div className={styles.dividerRight}></div>
      <div className={styles.iconGroup}>
        <SearchModalWithTrigger />
        <div className={styles.userProfileblock}>
          <ProfileDropdown renderResponsiveView={false} />
        </div>
        <CheckoutProvider>
          {loading ? <Spinner width={32} height={32} /> : <CartIcon />}
        </CheckoutProvider>
        <Button styleType="no-style" onClick={handleMenuToggle} className={styles.menuButton}>
          <span className={styles.menuIcon} />
        </Button>
      </div>
    </>
  );
}
